import * as amplitude from '@amplitude/analytics-browser'
import * as braze from '@braze/web-sdk'
import { analytics } from '../firebase'

const ANALYTICS_EVENTS = {
  HomeScreenLoaded: 'home_screen_loaded'
}

//** Common Log Event Method */
export const logEvent = (eventName, eventObject = {}) => {
  analytics.logEvent(eventName, eventObject) // firebase analytics
  ga4EventLog(eventName, eventObject)
  amplitudeEventLog(eventName, eventObject)
  brazeEventLog(eventName, eventObject)
}

//** gtag Tracking */
export const ga4EventLog = (eventName, eventObject) => {
  gtag('send', eventName, eventObject) // eslint-disable-line
}

//** Amplitude Initialisation */
export const amplitudeInit = (currentUser) => {
  if (currentUser && currentUser.tracker) {
    amplitude.init(window.__env.REACT_APP_AMPLITUDE_API_KEY, currentUser.tracker)
    amplitude.track(ANALYTICS_EVENTS.HomeScreenLoaded)
  } else {
    amplitude.init(window.__env.REACT_APP_AMPLITUDE_API_KEY, { defaultTracking: false })
    amplitude.track(ANALYTICS_EVENTS.HomeScreenLoaded)
  }
}

//** Amplitude Event Log */
export const amplitudeEventLog = (eventName, eventObject) => {
  amplitude.track(eventName, eventObject)
}

//** Braze Initialisation */
export const brazeInit = (currentUser) => {
  braze.initialize(window.__env.REACT_APP_BRAZE_SDK_KEY, {
    baseUrl: 'sdk.iad-07.braze.com'
  })
  if (currentUser && currentUser.tracker) {
    braze.changeUser(currentUser.tracker)
    braze.openSession()
    braze.logCustomEvent(ANALYTICS_EVENTS.HomeScreenLoaded)
  } else {
    braze.disableSDK()
  }
}

//** Braze Event Log */
export const brazeEventLog = (eventName, eventObject) => {
  braze.logCustomEvent(eventName, eventObject)
}
